import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@pw/batch-widgets";
import { FC, ReactNode } from "react";
import style from "./style.module.css";

interface props {
  children: ReactNode;
  showTooltip: boolean;
  content: string;
}
const ToolTipWrapper: FC<props> = ({
  children,
  showTooltip = false,
  content,
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        {showTooltip && (
          <TooltipContent className={style.tooltip}>
            <div>{content}</div>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export default ToolTipWrapper;
